@let selectedValue = value();
@let hasErrorValue = hasError();
@let scale = ratingScale();

@if (hasBox()) {
  <rt-box layout-vertical [class.rating-field__box--invalid]="hasErrorValue">
    <ng-container [ngTemplateOutlet]="content" />
  </rt-box>
} @else {
  <ng-container [ngTemplateOutlet]="content" />
}

@if (hasErrorValue) {
  <div class="rating-field__error">
    {{ 'app.evaluation_panel.errors.basic_required' | translate }}
  </div>
}

<ng-template #content>
  <rt-form-field>
    <div class="rating-field__label">
      {{ 'app.evaluation_panel.evaluation_score' | translate }}
      @if (required()) {
        <span
          class="rating-field__asterisk"
          [class.rating-field__asterisk--hidden]="selectedValue !== null"
          >*</span
        >
      }
    </div>

    @if (scale) {
      <rt-rating-scale
        [presentation]="scale.presentation"
        [range]="scale.range"
        [score]="selectedValue"
        [minLabel]="scale.points[0]?.label || ''"
        [maxLabel]="scale.points[scale.points.length - 1]?.label || ''"
        (scoreChange)="select($event)"
      />
    }
  </rt-form-field>
</ng-template>
